import { Link } from "react-router-dom";
import { XCircle, PawPrint } from "lucide-react";

export default function CancelPage() {
  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="cancel-page">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl ring-1 ring-zinc-100 p-10 text-center">
        <span className="mx-auto w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center mb-6">
          <PawPrint className="w-5 h-5 text-zinc-400" />
        </span>
        <XCircle className="w-10 h-10 text-zinc-300 mx-auto mb-4" />
        <h1 className="font-display font-bold text-2xl">Payment canceled</h1>
        <p className="mt-3 text-sm text-zinc-500 leading-relaxed">
          No charge was made. Your pack is still saved in case you want to pick up your order where you left off.
        </p>
        <Link
          to="/#packs"
          data-testid="cancel-back-link"
          className="mt-8 inline-block bg-brand text-white font-display font-semibold text-sm rounded-full px-8 py-3.5 hover:bg-brand-dark transition-colors"
        >
          Back to my pack
        </Link>
      </div>
    </div>
  );
}
